<template>
  <!-- ========================= -->
  <!-- TAB 5: LOCATION           -->
  <!-- ========================= -->
  <div>
    <div class="row mt-2"></div>
    <p class="bb-hdg mt-2 mb-3">Location Details</p>
    <!-- -------------- -->
    <!--      ROW 1     -->
    <!-- -------------- -->
    <div class="row">
      <!-- ---------------------- -->
      <!--   held item (switch)   -->
      <!-- ---------------------- -->
      <div class="col-auto pe-3">
        <enhanced-toggle
          style="
            --toggleWidth: 260px;
            --labelWidth: 160px;
            --switchWidth: 90px;
            --switchPos: 160px;
            height: 50px;
            border-radius: 10px;
            background-color: white;
          "
          :styleOff="`default`"
          :styleOn="`primary`"
          :labelOn="`Held`"
          :labelOff="`Not Held`"
          :checked="activeItem.held"
          @update:modelValue="onHeldToggle"
        >
        </enhanced-toggle>
      </div>
    </div>
    <!-- -------------- -->
    <!--      ROW 2     -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <div v-if="showStorageContainer">
        <!-- ---------------- -->
        <!--   storage (r/o)  -->
        <!-- ---------------- -->
        <div
          v-if="activeItem.tally_qty == 0"
          class="col form-group"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-left"
              value="Cannot select container when quantity is zero"
              id="capacity_enc"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="capacity_enc"
              >Capacity Enc</label
            >
          </div>
        </div>
        <!-- -------------------- -->
        <!--   storage (input)    -->
        <!-- -------------------- -->
        <div
          v-else
          class="col"
        >
          <div class="form-group">
            <div class="form-floating">
              <v-select
                :options="containers"
                :get-option-label="getContainerLabel"
                :reduce="reduceObject"
                class="form-control"
                placeholder="select..."
                :model-value="localItem.container"
                @keydown="onKeyDown($event)"
                :class="{ 'is-invalid': errorFields.includes('container') }"
                @click="clearInputError('container')"
                @update:modelValue="onContainerSelect"
                id="container"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <label
                class="bb-float-label"
                for="container"
                >Container</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- -------------- -->
    <!--      ROW 3     -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <div v-if="showStorageWornLocation">
        <!-- ----------------------------- -->
        <!--   worn (item) location (r/o)  -->
        <!-- ----------------------------- -->
        <div
          v-if="activeItem.tally_qty == 0"
          class="col form-group"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-left"
              value="Cannot select worn location when quantity is zero"
              id="worn_location"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="worn_location"
              >Worn Location</label
            >
          </div>
        </div>
        <div v-else>
          <!-- ------------------------------- -->
          <!--   worn (item) location (input)  -->
          <!-- ------------------------------- -->
          <div class="col">
            <div class="form-group">
              <div class="form-floating">
                <v-select
                  :options="wornLocations"
                  label="name"
                  :reduce="reduceObject"
                  class="form-control"
                  placeholder="select..."
                  :model-value="localItem.worn_location"
                  @keydown="onKeyDown($event)"
                  v-bind:class="{
                    'is-invalid': errorFields.includes('worn_location'),
                  }"
                  @click="clearInputError('worn_location')"
                  @update:modelValue="onWornLocationSelect"
                  id="worn_location"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
                <label
                  class="bb-float-label"
                  for="worn_location"
                  >{{ WornOrCarryLocation }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- -------------- -->
    <!--      ROW 4     -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <div
        v-if="
          localItem &&
          localItem.attachable &&
          !(itemType === 'Armour' && activeItem.equipped)
        "
      >
        <!-- ----------------------- -->
        <!--   attached location (r/o)  -->
        <!-- -------------------------- -->
        <div
          v-if="activeItem.tally_qty == 0"
          class="col form-group"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-left"
              value="Cannot select attached location when quantity is zero"
              id="attach_location"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="attach_location"
              >Attached Location</label
            >
          </div>
        </div>
        <!-- ---------------------------- -->
        <!--   attached location (input)  -->
        <!-- ---------------------------- -->
        <div
          v-else
          class="col"
        >
          <div class="form-group">
            <div class="form-floating">
              <v-select
                :options="attachLocations"
                :get-option-label="getAttachLocationLabel"
                :reduce="reduceObject"
                class="form-control"
                placeholder="select..."
                :model-value="localItem.attach_location"
                @keydown="onKeyDown($event)"
                v-bind:class="{
                  'is-invalid': errorFields.includes('attach_location'),
                }"
                @click="clearInputError('attach_location')"
                @update:modelValue="onAttachedLocationSelect"
                id="attach_location"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <label
                class="bb-float-label"
                for="attach_location"
                >Attached Location</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="localItem && localItem.attach_point"
      class="row mt-2 mb-2"
    >
      <div class="col-3 form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="attachedCount"
            id="attached_items_count"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="attached_items_count"
            >Attached Items</label
          >
        </div>
      </div>
      <!-- -------------- -->
      <!--     ROW 4      -->
      <!-- --------------       v-if="activeItem.contents_count_direct > 0"
-->
      <div
        v-if="showAttachedItemsIcon"
        class="col-4"
      >
        <div class="d-flex align-items-center">
          <span
            class="bb-tooltip-trigger d-inline-flex align-items-center me-2"
            v-tooltip:top="attachedTooltipText"
            @click.stop="manageAttached(activeItem)"
            @keydown.enter.prevent="manageAttached(activeItem)"
            @keydown.space.prevent="manageAttached(activeItem)"
            role="button"
            tabindex="0"
          >
            <img
              class="bbActionIcon"
              :src="attachedImg"
              alt="attached image"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import attachedImg from '../assets/images/bbAttached.png'

export default {
  name: 'ItemLocationTab',
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    localItem: {
      type: Object,
      required: true,
    },
    containers: {
      type: Array,
      required: true,
    },
    wornLocations: {
      type: Array,
      required: true,
    },
    attachLocations: {
      type: Array,
      required: true,
    },
    errorFields: {
      type: Array,
      required: true,
    },
    itemType: {
      type: String,
      required: true,
    },
    onHeldToggle: {
      type: Function,
      required: true,
    },
    onKeyDown: {
      type: Function,
      required: true,
    },
    getContainerLabel: {
      type: Function,
      required: true,
    },
    reduceObject: {
      type: Function,
      required: true,
    },
    clearInputError: {
      type: Function,
      required: true,
    },
    onContainerSelect: {
      type: Function,
      required: true,
    },
    onWornLocationSelect: {
      type: Function,
      required: true,
    },
    getAttachLocationLabel: {
      type: Function,
      required: true,
    },
    onAttachedLocationSelect: {
      type: Function,
      required: true,
    },
    manageAttached: {
      type: Function,
      required: true,
    },
    attachedCount: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    attachedImg,
  }),
  computed: {
    WornOrCarryLocation() {
      if (this.itemType === 'Armour') {
        return 'Carry Location'
      } else {
        return 'Worn Location'
      }
    },
    attachedTooltipText() {
      if (this.attachedCount === 1) {
        return 'Show 1 attached item'
      }

      return `Show ${this.attachedCount} attached items`
    },
    showAttachedItemsIcon() {
      return this.attachedCount > 0
    },
    showStorageContainer() {
      return this.activeItem.storeable && !this.activeItem.equipped
    },
    showStorageWornLocation() {
      return (
        this.activeItem.wearable &&
        !this.activeItem.held &&
        this.itemType !== 'Melee Weapon' &&
        this.itemType !== 'Ranged Weapon'
      )
    },
  },
}
</script>
